import React from "react"
import {
  faBan,
  faBusinessTime,
  faCheck,
  faEnvelope,
  faHourglassHalf,
  faThumbsDown,
  faThumbsUp,
  faUserShield,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const getShiftStatus = (shiftStatus: number) => {
  switch(shiftStatus) {
    case 0: return "Pending";
    case 1: return "Sent";
    case 2: return "Canceled";
  }
}

export const getHotelStatus = (hotelStatus: number) => {
  switch(hotelStatus) {
    case 0: return "No Hotel Required";
    case 1: return "Pending";
    case 2: return "Booked";
  }
}

export const getTStatus = (tStatus: number) => {
  switch(tStatus) {
    case 0:  return ""
    case 1:  return <FontAwesomeIcon size="sm" icon={faThumbsUp} />
    case 2:  return <FontAwesomeIcon size="sm" icon={faThumbsDown}/>
  }
}

export const getSStatus = (sStatus: number) => {
  switch(sStatus) {
    case 0: return ""
    case 1: return <FontAwesomeIcon size="sm" icon={faCheck} />
    case 2: return <FontAwesomeIcon size="sm" icon={faX}/>
    case 3: return <FontAwesomeIcon size="sm" icon={faEnvelope}/>
    case 4: return <FontAwesomeIcon size="sm" icon={faBan}/>
    case 5: return <FontAwesomeIcon size="xs" icon={faUserShield}/>
  }
}

export const getFatigueStatus = (worker: any, startTime: any) => {
  if(worker.isTraining) {
    return <FontAwesomeIcon icon={faBusinessTime} size="xs" />
  }

  if (worker.fatigueIndex === undefined || worker.fatigueIndex === null  || !startTime) {
    return;
  }

  const hour = Number(startTime.split(":")[0]);
  const shiftType = Number(hour) >= 6 && Number(hour) < 18 ? 'Day Shift' : 'Night Shift';

  if(worker?.userId === null && worker.fatigueIndex === null && worker.fatigueStatus === 3) {
    return <FontAwesomeIcon size={"sm"} icon={faHourglassHalf}/>
  }

  if(shiftType === 'Day Shift') {
    return worker.fatigueIndex > 35 ? (
      <FontAwesomeIcon size="sm" icon={faX} />
    ) : (
      <FontAwesomeIcon size="sm" icon={faCheck} />
    );
  } else if (shiftType === 'Night Shift') {
    return worker.fatigueIndex > 45 ? (
      <FontAwesomeIcon size="sm" icon={faX} />
    ) : (
      <FontAwesomeIcon size="sm" icon={faCheck} />
    );
  }
}

export const getRiskStatus = (riskIndex: any, isTraining: any) => {
  if(isTraining) {
    return <FontAwesomeIcon icon={faBusinessTime} size="xs" />
  }

  if (riskIndex == null) return "";

  return riskIndex.toFixed(2) > 1.60 ? (
    <FontAwesomeIcon size="sm" icon={faX} />
  ) : (
    <FontAwesomeIcon size="sm" icon={faCheck} />
  );
};

export const getRiskColor = (riskIndex: any, isTraining: any) => {
  if (riskIndex === undefined || riskIndex === null || isTraining) {
    return "white";
  }

  return riskIndex.toFixed(2) > 1.60  ? "red" : "#74c365";
}

export const getFatigueColor = (worker: any, startTime: any) => {
  if(worker.isTraining) {
    return;
  }

  if (worker.fatigueIndex === undefined || worker.fatigueIndex === null  || !startTime) {
    return "white";
  }

  if(worker?.userId === null && worker.fatigueIndex === null && worker.fatigueStatus === 3) {
    return '#F7DE3A';
  }

  const hour = Number(startTime.split(":")[0]);
  const shiftType = Number(hour) >= 6 && Number(hour) < 18 ? 'Day Shift' : 'Night Shift';

  if(shiftType === 'Day Shift') {
    return worker.fatigueIndex > 35 ? "red" : "#74c365";
  } else if (shiftType === 'Night Shift') {
    return worker.fatigueIndex > 45 ? "red" : "#74c365";
  }
};

export const getHStatus = (hotelStatus: number) => {
  switch(hotelStatus) {
    case 0: return ""
    case 1: return "MacRail";
    case 2: return "Other";
    case 3: return "Cancel";
  }
}

export const getHStatusColor = (hStatus: number) => {
  switch(hStatus) {
    case 0: 
      return "white";
    case 1:
      return "#ffc0cb";
    case 2:
      return "#90ee90";
    case 3:
      return "#FF0000";
  }
}

export const getBackgroundColor = (shiftStatus: number) => {
  switch(shiftStatus){
    case 0:
      return "#F7DE3A";
    case 1:
      return "#74c365";
    case 2:
      return "#FF0000";
    case 3:
      return "#00B050";
  }
};

export const getTStatusColor = (tStatus: number) => {
  switch(tStatus) {
    case 0: 
      return "white";
    case 1:
      return "#74c365";
    case 2:
      return "red";
  }
}

export const getSStatusColor = (sStatus: number) => {
  switch(sStatus) {
    case 0:
      return "white";
    case 1:
      return "#74c365";
    case 2:
      return "red";
    case 3:
      return "#f7de3a";
    case 4:
      return "#e0e0e0";
    case 5:
      return "#5bc0de";
  }
}

export const getSColor = (value: number) => {
  switch (value) {
    case 0:
      return "white";
    case 1:
      return "#90ee90";
    case 2:
      return "red";
    case 3:
      return "#f7de3a";
    case 4:
      return "#e0e0e0";
    case 5:
      return "#5bc0de";
  }
}

export const getTColor = (value: number) => {
  switch (value) {
    case 0:
      return "white";
    case 1:
      return "#90ee90";
    case 2:
      return "red";
  }
}

export const getHColor = (signedInValue: number) => {
  switch (signedInValue) {
    case 0:
      return "white";
    case 1:
      return "#ffc0cb";
    case 2:
      return "#90ee90";
    case 3:
      return "#FF0000";
  }
};

export const getStatus = (status: any) => {
  switch(status) {
    case 0: 
      return 'Pending'
    case 1:
      return 'Approved'
    case 2:
      return 'Denied'
    case 3:
      return 'Not Verified'
  }
}

export const getFatigue = (hStatus: number) => {
  switch(hStatus) {
    case 0: return ""
    case 1: return <FontAwesomeIcon size="sm" icon={faCheck} />
    case 2: return <FontAwesomeIcon size="sm" icon={faX}/>
    case 3: return <FontAwesomeIcon size="sm" icon={faHourglassHalf} />
  }
}

export const getResponseScoreStatus = (responseScore: any) => {
  switch(responseScore) {
    case 0: 
      return 'Unknown'
    case 1:
      return 'Mobile'
    case 2:
      return 'RT'
    case 3:
      return 'SMS'
  }
}
